import "./SuvaiAbout.scss"
import { sortByOrderAscending } from "../../helper/helper";
import { useEffect } from "react";
import Button from "../../components/button/Button";
import { useSelector } from "react-redux";

const SuvaiAbout = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "about")
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getComponentOneTextContent = (data) => {
        return (
            <div className="SuvaiAbout-inner-textContWarpper">
                <div className="SuvaiAbout-inner-textContWarpper-textCont">
                    {data.map((content, key) => <div
                        key={key}
                        dangerouslySetInnerHTML={{ __html: content?.text }}
                        className="SuvaiAbout-inner-textContWarpper-textCont-content" />)}
                </div>
            </div>
        )
    }
    const getComponentOneImageContent = (props) => {
        return (
            <div
                className="SuvaiAbout-inner-imageCont"
                style={{
                    backgroundImage: `linear-gradient(180deg, rgba(16, 18, 19, 0) 0%, rgba(16, 18, 19, 0.6) 40%, rgba(16, 18, 19, 0.6) 60%, rgba(16, 18, 19, 0) 100%), url(${props?.bgSrc})`
                }} >
                <div
                    className="SuvaiAbout-inner-imageCont-header"
                >
                    {props.text}

                </div>
            </div>
        )
    }
    const getComponentOneContent = (component) => {
        switch (component.ID) {
            case "SuvaiAbout-componentOne-TextContainer":
                return getComponentOneTextContent(component.Data)
            case "SuvaiAbout-componentOne-ImageContainer":
                return getComponentOneImageContent(component.Props)
            default:
                return <div />
        }

    }
    const getComponentTwoTextInnerContent = (component) => {
        return (
            <div className="SuvaiAbout-inner2-textContWarpper-textCont2"
            >
                <div
                    className="SuvaiAbout-inner2-textContWarpper-textCont2-header">
                    {component?.Props?.text}
                </div>
                {component?.Data.map((content, key) => <div
                    key={key}
                    dangerouslySetInnerHTML={{ __html: content?.text }}
                    className="SuvaiAbout-inner2-textContWarpper-textCont2-content" />)}
            </div>
        )
    }
    const getComponentTwoTextContentContent = (component) => {
        switch (component.ID) {
            case "SuvaiAbout-componentTwo-TextContainer-vertical":
                return <div class="SuvaiAbout-inner2-textContWarpper-vertical">{component?.Props?.text}</div>

            case "SuvaiAbout-componentTwo-TextContainer-content":
                return getComponentTwoTextInnerContent(component)
            default:
                return <div />
        }
    }
    const getComponentTwoTextContent = (components) => {
        return (
            <div className="SuvaiAbout-inner2-textContWarpper">
                {sortByOrderAscending(components).map((component, key) => {
                    return getComponentTwoTextContentContent(component)
                })}
            </div>
        )
    }
    const getComponentTwoContent = (component) => {
        switch (component.ID) {
            case "SuvaiAbout-componentTwo-TextContainer":
                return getComponentTwoTextContent(component.Components)
            case "SuvaiAbout-componentTwo-ImageContainer":
                return <div
                    className="SuvaiAbout-inner2-imageCont"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${component?.Props?.bgSrc})`
                    }} >
                </div>
            default:
                return <div />
        }

    }
    const getComponentOne = (components) => {
        return (
            <div className="SuvaiAbout-inner">
                {sortByOrderAscending(components).map((component, key) => {
                    return getComponentOneContent(component)
                })}
            </div>
        )
    }
    const getComponentTWo = (components) => {
        return (
            <div className="SuvaiAbout-inner2">
                {sortByOrderAscending(components).map((component, key) => {
                    return getComponentTwoContent(component)
                })}
            </div>
        )
    }
    const getcomponentFixedContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-MobileFixed-button":
                return <Button
                    text={component?.Props.btnText}
                    padding={component?.Props?.padding}
                    width={component?.Props.width}
                    type={component?.Props.type}
                    onClick={() => {
                        if (component?.Props?.href && component?.Props?.href !== "") {
                            window.open(component?.Props?.href, '_blank')
                        }
                    }} />
            default:
                return <div />
        }

    }
    const getcomponentFixedContainer = (components) => {
        return (<div className="SuvaiHome-MobileFixed">
            {sortByOrderAscending(components).map((component, key) => {
                return getcomponentFixedContainerComponents(component)
            })}
        </div>)
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "SuvaiAbout-componentOne":
                return getComponentOne(component.Components)
            case "SuvaiAbout-componentTwo":
                return getComponentTWo(component.Components)
            case "SuvaiHome-MobileFixed":
                return getcomponentFixedContainer(component?.Components)

            default:
                return <div />
        }

    }
    return (
        <div className="SuvaiAbout">
            {sortByOrderAscending(Components).map((component, key) => {
                return getComponents(component)
            })}
        </div>
    )
}
export default SuvaiAbout